
import { defineComponent, ref, getCurrentInstance, onMounted } from 'vue';
import { Order } from '@/utils/api/order';
import { ElMessage } from 'element-plus';
export default defineComponent({
  name: 'all',
  setup() {
    const tableData = ref([]);
    const getOrder = () => {
      Order.getMyOrder()
        .then((res) => {
          if (res.status === 200) {
            (tableData as any).value = res.data;
            console.log(tableData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    onMounted(() => {
      getOrder();
    });
    // const { ctx } = getCurrentInstance();
    const handleEdit = () => {
      ElMessage.success({
        message: '申请成功,3个工作日后在微信发票中心查看',
        type: 'success',
      });
    };
    return {
      tableData,
      getOrder,
      handleEdit,
    };
  },
});
